
import { Suspense, lazy, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import "./App.css";

// import { Ecommerce, Login, NotFound } from './pages';
import MainLayout from './Layout/MainLayout';
import Unauthorized from './pages/Unauthorized';
import RequireAuth from './routes/RequiredAuth';

//fonts
import "./assets/fonts/NotoSansKR-Black.otf";
import "./assets/fonts/NotoSansKR-Bold.otf";
import "./assets/fonts/NotoSansKR-Light.otf";
import "./assets/fonts/NotoSansKR-Medium.otf";
import "./assets/fonts/NotoSansKR-Regular.otf";
import "./assets/fonts/NotoSansKR-Thin.otf";
import ProccessAdminClientMainScreen from "./pages/ProcessAdminRecordAllocation/ProcessAdminClientMain";
import ProccessAdminPlatformMainScreen from "./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformMain";
import ProccessAdminPlatformMainNewScreen from './pages/ProcessAdminRecordAllocation/ProccessAdminPlatformMainNewScreen';
import MyProfile from './pages/MyProfile';
import MyOrganization from './pages/MyOrganization';
import TeleCallerPlatfomMain from './pages/AllViewTeleCaller/TeleCallerPlatfomMain';
import ProccessAdminPlatformDashboardMainScreen from './pages/ProcessAdminRecordAllocation/ProccessAdminPlatformDashboardMainScreen';
import { getLocalStorage } from './utils/localStorage';


const Login = lazy(() => import("./pages/Login"))
const NotFound = lazy(() => import("./pages/NotFound"))
const UserList = lazy(() => import("./pages/admin/UserList"))
const ExcelFileAllocationScreen = lazy(() => import("./pages/fileAllocation/ExcelFileUpload"))
const ProcessAdminRecordAllocationScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminRecordAllocation"))
const ProcessAllocationDetailScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAllocationDetail"));
const AllRecordViewScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/AllViewScreen"));
const TeamLeadsToTeleAllocationScreen = lazy(() => import("./pages/TeamLeads/TeamLeadsToTeleCallers"))
const TeleCallerScreen = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerScreen"))
const TeleCallerScreenAllocation = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerScreenAllocation"))
const TeleCallerCustomerView = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerCustomerView"))

// const AdminTdfUsersScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/AdminTdfUsers"));
const TeleCallersDashboard = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerDashboard"));

const TdfUserDetailScreen = lazy(() => import("./components/detail/TdfUserDetailScreen"))
const TeleCallerTdfUsersScreen = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerTdfUsers"))
const TeleCallerTdfUsersNew = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerTdfUsersNew"))
const CampaignScreen = lazy(() => import("./pages/campaign/CampaignScreen"))
const UtmScreen = lazy(() => import("./pages/campaign/UtmScreen"))


const CreateBlogScreen = lazy(() => import("./pages/BlogPost/CreateBlogScreen"))
const BlogListingScreen = lazy(() => import("./pages/BlogPost/BlogListing"))
const BlogDetailPage = lazy(() => import("./pages/BlogPost/BlogDetailPage"));

const TdfUserAllocationToTcScreen = lazy(() => import("./pages/TeamLeads/TdfUserAllocationToTc"));
const TdfUserFileIdAllocationScreen = lazy(() => import("./pages/TeamLeads/TdfUserFileIdAllocation"));

const TdfUserAllocToTcDetailScreen = lazy(() => import("./pages/TeamLeads/TdfUserAllocToTcDetail"));

// const TdfUserDetailViewTlScreen = lazy(() => import("./pages/TeamLeads/TdfUserDetailView"));
const TeamLeadDashboardScreen = lazy(() => import("./pages/TeamLeads/TeamLeadDashboard"));

const TdfProcessAdminAllocationToTlScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformAllocation"));
const TdfProcessAdminPlatformAllocationNew = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformAllocationNew"));
const ProcessAdminTdfAllocFileIdToTlScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminTdfAllocFileIdToTl"));
const ProcessAdminTdfAllocFileIdToTlScreenNew = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminTdfAllocFileIdToTlScreenNew"));
const ProcessAdminTdfAllocToTlDetailScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformAllocToTlDetail"));
const ProcessAdminPlatformAllocToTlDetailNew = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformAllocToTlDetailNew"));
const ProcessAdminDashboardScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminDashboard"));
const EditBlogScreen = lazy(() => import("./pages/BlogPost/EditBlogScreen"));

const ProcessAdminPlatformUserDetailScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformUserDetailScreen"))
const ProcessAdminPlatformUserDetailScreenNew = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminPlatformUserDetailScreenNew"))

// this is the old screen for the user
const ProcessAdminClientCustomerViewScreen = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminClientCustomerView"));
//now creating the new UI Screen for the user details view with the updated UI
const ProcessAdminClientCustomerViewScreenNew = lazy(() => import("./pages/ProcessAdminRecordAllocation/ProcessAdminClientCustomerViewScreen"));

const CampaignMainScreen = lazy(() => import("./pages/campaign/CampaignMainScreen"));
const UtmMainScreen = lazy(() => import("./pages/campaign/UtmMainScreen"));

const CreateCampaignScreen = lazy(() => import("./pages/campaign/CreateCampaignScreen"));
const CreateUtmScreen = lazy(() => import("./pages/campaign/CreateUtmScreen"));



const ProcessAdminCampaignMainScreen = lazy(() => import("./pages/campaign/ProcessAdminCampaignMain"));
const ProcessAdminCampaignApproval = lazy(() => import("./pages/campaign/ProcessAdminCampaignApproval"));
const CampaignDetailsScreen = lazy(() => import("./pages/campaign/CampaignDetail"));


// tele performance
const TelePerformanceNavigationScreen = lazy(() => import("./pages/TeleDashboard/TelePerformanceNav"));
const TeleAttempedScreen = lazy(() => import("./pages/TeleDashboard/TeleAttempedScreen"));
const TeleConnectedScreen = lazy(() => import("./pages/TeleDashboard/TeleConnectedScreen"));

const TeamLeadPlatformMainScreen = lazy(() => import("./pages/TeamLeads/TeamLeadPlatformMain"));
const TeamLeadPlatformMainNew = lazy(() => import("./pages/TeamLeads/TeamLeadPlatformMainNew"));
const TeamLeadDashboardMain = lazy(() => import("./pages/TeamLeads/TeamLeadDashboardMain"))
const TeamLeadClientMainScreen = lazy(() => import("./pages/TeamLeads/TeamLeadClientMain"));
const TemplateMainScreen = lazy(() => import("./pages/campaign/TemplateMainScreen"));

// new dashboard
const AdminDashboard = lazy(() => import("./components/Dashboard/AdminDashboard"));
// campaign reporting dashboard
const CampaignReportingDashboard = lazy(() => import("./pages/campaign/CampaignReportingDashboard"));

const CrmUserList = lazy(() => import("./pages/admin/CrmUserList"));
const CreateOrganization = lazy(() => import("./pages/OrgAdmin/CreateOrganization"));
const OrganizationListScreen = lazy(() => import("./pages/OrgAdmin/OrganizationListScreen"));
const OrganizationListDetailScreen = lazy(() => import("./pages/OrgAdmin/OrganizationListDetailScreen"));
const OrgUsersDetailScreen = lazy(() => import("./pages/OrgAdmin/OrgUsersDetailScreen"));
const OrgUsersEditScreen = lazy(() => import("./pages/OrgAdmin/OrgUsersEditScreen"));
const OrgAdminScreen = lazy(() => import("./pages/OrgAdmin/OrgAdminScreen"));
const OrgAdminAddUserScreen = lazy(() => import("./pages/OrgAdmin/OrgAdminAddUserScreen"));
const OrgAdminListScreen = lazy(() => import("./pages/OrgAdmin/OrgAdminListScreen"));
const TeamLeadClientMetaList = lazy(() => import("./pages/TeamLeads/TeamLeadClientMetaList"));
const TeamLeadAllRecordViewScreen = lazy(() => import("./pages/TeamLeads/TeamLeadAllRecordViewScreen"));
const TeamLeadClientAllocationToTc = lazy(() => import("./pages/TeamLeads/TeamLeadClientAllocationToTc"));

const UserActionScreen = lazy(() => import("./pages/AllViewTeleCaller/UserActionScreen"))
const UserActionScreenNew = lazy(() => import("./pages/AllViewTeleCaller/UserActionScreenNew"))


const TdfUserActionDetailScreen = lazy(() => import("./components/detail/TdfUserActionDetailScreen"))
// route for the manager role commented for prod
const ProcessManagerReallocation = lazy(() => import("./pages/Reallocation/ProcessManagerReallocation"));
const ProcessManagerReallocationNewScreen = lazy(() => import("./pages/Reallocation/ProcessManagerReallocationNewScreen"));


const ClientAdminCampaignDashboard = lazy(() => import("./pages/CampaignDashboards/AdminCampaignDashboard"))


// new Items for Ui Changes 

const ClientAllocationMainScreen = lazy(() => import("./pages/Client-Allocation/ClientAllocationMainScreen"))
const MetaRecordScreen = lazy(() => import("./pages/Client-Allocation/MetaRecordScreen"))
const MetaRecordDetailListScreen = lazy(() => import("./pages/Client-Allocation/MetaRecordDetailListScreen"))
const AllRecordListScreen = lazy(() => import("./pages/Client-Allocation/AllRecordScreen"))
const FileUploadScreen = lazy(() => import("./pages/Client-Allocation/FileUploadScreen"))
const ClientCampaignMainScreen = lazy(() => import("./pages/campaign/client-campaign/ClientCampaignMainScreen"))
const ClientCampaignListScreen = lazy(() => import("./pages/campaign/client-campaign/ClientCampaignListScreen"));
const ClientCampaignDetailScreen = lazy(() => import("./pages/campaign/client-campaign/ClientCampaignDetailScreen"))

const ClientCampaignDetailsScreen = lazy(() => import("./pages/Client-Allocation/ClientCampaignDetailsScreen"))
const ClientCampaignDetailsScreenDetails = lazy(() => import("./pages/Client-Allocation/ClientCampaignDetailsScreenDetails"))

const StitchedTemplateDetailScreen = lazy(() => import("./pages/campaign/StitchedCampaign/StitchedTemplateDetailScreen"))
const AllLeadsScreen = lazy(() => import("./pages/campaign/client-campaign/AllLeadsScreen"))
const AllLeadsDetailScreen = lazy(() => import("./pages/campaign/client-campaign/AllLeadsDetailScreen"))
const TeamLeadDashboardNew = lazy(() => import("./pages/TeamLeads/TeamLeadDashboardNew"))
const TeamLeadDashboardClient = lazy(() => import("./pages/TeamLeads/TeamLeadDashboardClient"))
const TeleCallerHotLeads = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerHotLeads"))
const TeleCallerHotLeadsDetailScreen = lazy(() => import("./pages/AllViewTeleCaller/TeleCallerHotLeadsDetailScreen"))
const IVRTemplateDetailScreen = lazy(() => import("./components/campaign/IVRTemplate/IVRTemplateDetailScreen"))


// client dashboard 
const ClientDashboardScreen = lazy(() => import("./pages/Client-Dashboard/ClientDashboardScreen"))
function LoaderScreen() {
    return (
        <>
            <div className="loading">Loading&#8230;</div>
        </>
    )
}

// ─── Role Constants ───────────────────────────────────────────────────────────
const ROLES = {
    CRM_ADMIN: "ROLE_CRM_ADMIN",
    ADMIN: "ROLE_ADMIN",
    MANAGER: "ROLE_MANAGER",
    TEAM_LEAD: "ROLE_TEAM_LEAD",
    TELE_CALLER: "ROLE_TELE_CALLER",
    DS: "ROLE_DS",
};

const customerViewStyle = { marginTop: "10px", marginRight: "10px" };

// ─── App ──────────────────────────────────────────────────────────────────────
const App = () => {
    const navigate = useNavigate();

    const token = localStorage.getItem("USER_AUTH");
    if (token === "undefined") {
        localStorage.clear();
        navigate("/login");
    }

    return (
        <Suspense fallback={<LoaderScreen />}>
            <Routes>
                <Route path="/" element={<MainLayout />}>

                    {/* ── Public ── */}
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/unauthorized" element={<Unauthorized />} />
                    <Route path="*" element={<NotFound />} />

                    {/* ── CRM Admin ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.CRM_ADMIN]} />}>
                        <Route path="/home/createOrganization" element={<CreateOrganization />} />
                        <Route path="/home/createOrganization/:id" element={<CreateOrganization />} />
                        <Route path="/home/organizationList" element={<OrganizationListScreen />} />
                        <Route path="/home/organizationList/:id" element={<OrganizationListDetailScreen />} />



                        <Route path="/home/organizationList/:id/templates" element={<TemplateMainScreen />} />
                        <Route path="/home/organizationList/templates/details/:id" element={<IVRTemplateDetailScreen />} />


                        <Route path="/home/organizationList/user/:id" element={<OrgUsersDetailScreen />} />
                        <Route path="/home/organizationList/editUser/:id" element={<OrgUsersEditScreen />} />

                        <Route path="/home/campaigns" element={<Navigate to="/home/campaigns/templates" replace />} />
                        <Route path="/home/campaigns" element={<ProcessAdminCampaignMainScreen />}>
                            <Route path="/home/campaigns/templates" element={<TemplateMainScreen />} />
                        </Route>
                    </Route>

                    {/* ── Admin + Manager ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.ADMIN, ROLES.MANAGER]} />}>

                        {/* Process Record Allocation (Client) */}
                        <Route path="/home/processRecordAllocation" element={<Navigate to="/home/processRecordAllocation/clientrecord" replace />} />
                        <Route path="/home/processRecordAllocation" element={<ProccessAdminClientMainScreen />}>
                            <Route index path="/home/processRecordAllocation/clientrecord" element={<ProcessAdminRecordAllocationScreen />} />
                            <Route path="/home/processRecordAllocation/clientrecord/:id" element={<ProcessAllocationDetailScreen />} />
                            <Route path="/home/processRecordAllocation/clientrecord/details/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
                            <Route path="/home/processRecordAllocation/records" element={<AllRecordViewScreen />} />
                            <Route path="/home/processRecordAllocation/records/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
                        </Route>

                        {/* Process Record Allocation (Platform) */}
                        <Route path="/home/processRecordPlatformAllocation" element={<ProccessAdminPlatformMainNewScreen />}>
                            <Route index path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl" element={<TdfProcessAdminPlatformAllocationNew />} />
                            <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
                            <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl" element={<ProcessAdminTdfAllocFileIdToTlScreenNew />} />
                            <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl/:id" element={<ProcessAdminPlatformAllocToTlDetailNew />} />
                            <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl/detail/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
                        </Route>

                        {/* Dashboards */}
                        <Route path="/home/tdfAdminDashboard" element={<ProcessAdminDashboardScreen />} />
                        <Route path="/home" element={<ProccessAdminPlatformDashboardMainScreen />}>
                            <Route path="/home/adminDashboard" element={<AdminDashboard />} />
                            <Route path="/home/campaignDashboard" element={<CampaignReportingDashboard />} />
                        </Route>

                        {/* Teleperformance */}
                        <Route path="/home/teleperformance" element={<TelePerformanceNavigationScreen />}>
                            <Route index path="/home/teleperformance/attempted" element={<TeleAttempedScreen />} />
                            <Route path="/home/teleperformance/connected" element={<TeleConnectedScreen />} />
                        </Route>

                        {/* User Management */}
                        <Route path="/home/addUser" element={<Navigate to="/home/addUser/list" replace />} />
                        <Route path="/home/addUser" element={<OrgAdminScreen />}>
                            <Route index path="/home/addUser/list" element={<OrgAdminListScreen />} />
                            <Route path="/home/addUser/createUser" element={<OrgAdminAddUserScreen />} />
                            <Route path="/home/addUser/list/:id" element={<OrgUsersDetailScreen />} />
                            <Route path="/home/addUser/list/editUser/:id" element={<OrgUsersEditScreen />} />
                        </Route>

                        {/* File Upload / Reallocation */}
                        <Route path="processRecordAllocation/:type/:id" element={<ProcessManagerReallocation />} />
                        <Route path="/home/processRecordAllocation" element={<ProccessAdminClientMainScreen />}>
                            <Route path="/home/processRecordAllocation/fileupload" element={<ExcelFileAllocationScreen />} />
                        </Route>
                    </Route>

                    {/* ── Admin Only ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.ADMIN]} />}>
                        <Route path="/home/myOrganization" element={<MyOrganization />} />
                        <Route path="/home/myProfile/Edituser" element={<CreateOrganization />} />
                    </Route>

                    {/* ── Admin + Manager + Team Lead ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_LEAD]} />}>
                        <Route path="/home/campaign-Dashboard-stats" element={<ClientAdminCampaignDashboard />} />

                        <Route path="/home/allocation" element={<ClientAllocationMainScreen />}>
                            <Route index element={<Navigate to="metadata" replace />} />
                            <Route path="metadata" element={<MetaRecordScreen />} />
                            <Route path="metadata/:id" element={<MetaRecordDetailListScreen />} />
                            <Route path="metadata/ClientListDetailsScreen" element={<ClientCampaignDetailsScreen />} />
                            <Route path="metadata/ClientListDetailsScreen/details/:id" element={<ClientCampaignDetailsScreenDetails />} />
                            <Route path="metadata/details/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
                            <Route path="metadata/:type/:id" element={<ProcessManagerReallocationNewScreen />} />
                            <Route path="all-records" element={<AllRecordListScreen />} />
                            <Route path="all-records/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
                            <Route path="file-process" element={<FileUploadScreen />} />
                        </Route>
                    </Route>

                    {/* ── Team Lead ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.TEAM_LEAD]} />}>

                        {/* Platform allocation */}
                        <Route path="/home/teamLead/" element={<Navigate to="/home/teamLead/teamLeadAllocToTele" replace />} />
                        <Route path="/home/teamLead/" element={<TeamLeadPlatformMainNew />}>
                            <Route index path="/home/teamLead/teamLeadAllocToTele" element={<TdfProcessAdminPlatformAllocationNew />} />
                            <Route path="/home/teamLead/teamLeadAllocToTele/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
                            <Route path="/home/teamLead/teamLeadAllocFileIdToTele" element={<ProcessAdminTdfAllocFileIdToTlScreenNew />} />
                            <Route path="/home/teamLead/teamLeadAllocFileIdToTele/:id" element={<ProcessAdminPlatformAllocToTlDetailNew />} />
                            <Route path="/home/teamLead/teamLeadAllocFileIdToTele/detail/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
                        </Route>

                        {/* Team Lead Dashboard */}
                        <Route path="/home/teamLeadDashboard" element={<TeamLeadDashboardMain />}>
                            <Route path="/home/teamLeadDashboard/platform" element={<TeamLeadDashboardNew />} />
                            <Route path="/home/teamLeadDashboard/Client" element={<TeamLeadDashboardClient />} />
                        </Route>

                        {/* Client-side Team Lead allocation */}
                        <Route path="/home/client/teamLead/" element={<Navigate to="/home/client/teamLead/teamLeadAllocToTele" replace />} />
                        <Route path="/home/client/teamLead/" element={<TeamLeadClientMainScreen />}>
                            <Route index path="/home/client/teamLead/teamLeadAllocToTele" element={<TeamLeadAllRecordViewScreen />} />
                            <Route path="/home/client/teamLead/teamLeadAllocToTele/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
                            <Route path="/home/client/teamLead/metaDataList" element={<TeamLeadClientMetaList />} />
                            <Route path="/home/client/teamLead/metaDataList/:id" element={<TeamLeadClientAllocationToTc />} />
                            <Route path="/home/client/teamLead/metaDataList/detail/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
                        </Route>
                    </Route>

                    {/* ── Manager + Team Lead ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.MANAGER, ROLES.TEAM_LEAD]} />}>
                        <Route path="/home/campaign" element={<ClientCampaignMainScreen />}>
                            <Route path="allLeads" element={<AllLeadsScreen />} />
                            <Route path="allLeads/:id" element={<AllLeadsDetailScreen />} />
                        </Route>
                    </Route>

                    {/* ── Tele Caller ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.TELE_CALLER]} />}>
                        <Route path="/home/teleCallers" element={<TeleCallerScreenAllocation />} />
                        <Route path="/home/teleCallers/customerView/:id" element={<div style={customerViewStyle}><ProcessAdminClientCustomerViewScreenNew /></div>} />
                        <Route path="/home/hotLeads" element={<TeleCallerHotLeads />} />
                        <Route path="/home/hotLeads/:id" element={<TeleCallerHotLeadsDetailScreen />} />

                        {/* Platform routes for tele callers */}
                        <Route path="/home/" element={<TeleCallerPlatfomMain />}>
                            <Route path="/home/teleTdfUsers" element={<TeleCallerTdfUsersNew />} />
                            <Route path="/home/teleTdfUsers/:id" element={<div style={customerViewStyle}><ProcessAdminPlatformUserDetailScreenNew /></div>} />
                            <Route path="/home/userActions" element={<UserActionScreenNew />} />
                            <Route path="/home/userActions/:id" element={<div style={customerViewStyle}><ProcessAdminPlatformUserDetailScreenNew /></div>} />
                        </Route>
                    </Route>

                    {/* ── DS (Digital/Data Specialist) ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.DS]} />}>
                        <Route path="/home/utm/" element={<Navigate to="/home/utm/records" replace />} />
                        <Route path="/home/utm/" element={<UtmMainScreen />}>
                            <Route index path="/home/utm/records" element={<UtmScreen />} />
                            <Route path="/home/utm/createCampaign/" element={<CreateUtmScreen />} />
                        </Route>
                        <Route path="/home/campaigns" element={<Navigate to="/home/campaigns/createCampaign/" replace />} />
                        <Route path="/home/campaigns" element={<ProcessAdminCampaignMainScreen />}>
                            <Route path="/home/campaigns/createCampaign/" element={<CreateCampaignScreen />} />
                        </Route>
                    </Route>

                    {/* ── CRM Admin + Admin + Manager + Team Lead + DS ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.CRM_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_LEAD, ROLES.DS]} />}>
                        <Route path="/home/myProfile" element={<MyProfile />} />

                        <Route path="/home/campaigns" element={<Navigate to="/home/campaigns/records" replace />} />
                        <Route path="/home/campaigns" element={<ProcessAdminCampaignMainScreen />}>
                            <Route index path="/home/campaigns/records" element={<ProcessAdminCampaignApproval />} />
                            <Route path="/home/campaigns/records/:id" element={<CampaignDetailsScreen />} />
                        </Route>

                        <Route path="/home/campaign" element={<ClientCampaignMainScreen />}>
                            <Route index element={<Navigate to="list" replace />} />
                            <Route path="list" element={<ClientCampaignListScreen />} />
                            <Route path="list/:id" element={<ClientCampaignDetailScreen />} />
                            <Route path="templates" element={<TemplateMainScreen />} />
                            <Route path="templates/:id" element={<StitchedTemplateDetailScreen />} />
                            <Route path="templates/details/:id" element={<IVRTemplateDetailScreen />} />
                        </Route>
                    </Route>

                    {/* ── CRM Admin + Manager + Admin ── */}
                    <Route path="/home" element={<RequireAuth allowedRoles={[ROLES.CRM_ADMIN, ROLES.MANAGER, ROLES.ADMIN]} />}>
                        <Route path="/home/analytic-dashbaord" element={<ClientDashboardScreen />} />
                        <Route path="/home/details/:id" element={<MetaRecordDetailListScreen />} />
                    </Route>

                </Route>
            </Routes>
        </Suspense>
    );
};

// const App = (props) => {
//     const navigate = useNavigate();
//     const token = localStorage.getItem("USER_AUTH");
//     if (token === "undefined") {
//         localStorage.clear();
//         navigate("/login");
//     }
//     return (
//         <>
//             <Suspense fallback={<LoaderScreen />}>

//                 <Routes>
//                     <Route path='/' element={<MainLayout />}>
//                         {/* Public routes */}
//                         <Route path="/" element={<Login />} />
//                         <Route path="/login" element={<Login />} />
//                         <Route exact path="/unauthorized" element={<Unauthorized />} />
//                         <Route path="*" element={<NotFound />} />

//                         {/* Protected routes */}
//                         {/* tested routes start */}
//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN"]} />}>
//                             {/* these are the routes when org flow does not exit so commented these routes, start  */}
//                             {/* <Route path="/home/users" element={<UserList />} />
//                             <Route path="/home/createuser" element={<CreateUserScreen />} />
//                             <Route path="/home/users/edituser" element={<EditUserScreen />} />
//                             <Route path="/home/users/:id" element={<UserDetailPage />} />
//                             <Route path="/home/userslist" element={<CrmUserList />} /> */}
//                             {/* these are the routes when org flow does not exit so commented these routes, end  */}



//                             <Route path="/home/createOrganization" element={<CreateOrganization />} />
//                             <Route path="/home/organizationList" element={<OrganizationListScreen />} />
//                             <Route path="/home/organizationList/:id" element={<OrganizationListDetailScreen />} />
//                             <Route path="/home/createOrganization/:id" element={<CreateOrganization />} />
//                             <Route path="/home/organizationList/user/:id" element={<><OrgUsersDetailScreen /></>} />
//                             <Route path="/home/organizationList/editUser/:id" element={<><OrgUsersEditScreen /></>} />

//                             <Route path="/home/campaigns" element={<Navigate to="/home/campaigns/templates" replace />} />
//                             <Route path="/home/campaigns" element={<ProcessAdminCampaignMainScreen />}>
//                                 <Route path='/home/campaigns/templates' element={<TemplateMainScreen />} />
//                             </Route>
//                             {/* <Route path="*" element={<NotFound/>} /> */}
//                         </Route>

//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]} />}>
//                             <Route path="/home/processRecordAllocation" element={<Navigate to="/home/processRecordAllocation/clientrecord" replace />} />
//                             <Route path="/home/processRecordAllocation" element={<ProccessAdminClientMainScreen />}>
//                                 <Route index path="/home/processRecordAllocation/clientrecord" element={<ProcessAdminRecordAllocationScreen />} />
//                                 <Route path="/home/processRecordAllocation/records" element={<AllRecordViewScreen />} />
//                                 {/* old Ui routes */}
//                                 <Route path="/home/processRecordAllocation/records/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
//                                 {/* old Ui routes end */}

//                                 <Route path="/home/processRecordAllocation/clientrecord/:id" element={<ProcessAllocationDetailScreen />} />
//                                 <Route path="/home/processRecordAllocation/clientrecord/details/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
//                             </Route>
//                             {/* @theduefactory.com routes start */}
//                             <Route path="/home/processRecordPlatformAllocation" element={<ProccessAdminPlatformMainScreen />}>
//                                 {/* <Route index path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl" element={<TdfProcessAdminAllocationToTlScreen />} />  */}
//                                 {/* commeting and replacing the routes components for new UI */}
//                                 {/* creating new routes for new screen start */}
//                                 {/* <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} /> */}
//                                 {/* <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl/new/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} /> */}
//                                 {/* creating new routes for new screen start */}

//                                 {/* <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl" element={< ProcessAdminTdfAllocFileIdToTlScreen />} /> */}


//                                 {/* <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl/:id" element={<ProcessAdminTdfAllocToTlDetailScreen />} /> */}
//                                 {/* <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl/detail/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} /> */}
//                             </Route>
//                             {/* @theduefactory.com routes end */}
//                             {/* created new main screen with navigations buttons for the child screen start */}
//                             <Route path="/home/processRecordPlatformAllocation" element={<ProccessAdminPlatformMainNewScreen />}>
//                                 <Route index path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl" element={<TdfProcessAdminPlatformAllocationNew />} />
//                                 <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocToTl/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
//                                 <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl" element={<ProcessAdminTdfAllocFileIdToTlScreenNew />} />
//                                 <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl/:id" element={<ProcessAdminPlatformAllocToTlDetailNew />} />
//                                 <Route path="/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl/detail/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />



//                             </Route>

//                             {/* created new main screen with navigations buttons for the child screen end */}



//                             <Route path="/home/tdfAdminDashboard" element={< ProcessAdminDashboardScreen />} />

//                             {/* added a layer for @theduefactory.com start */}
//                             <Route path="/home" element={<ProccessAdminPlatformDashboardMainScreen />}>
//                                 <Route path="/home/adminDashboard" element={<AdminDashboard />} />
//                                 <Route path="/home/campaignDashboard" element={<CampaignReportingDashboard />} />
//                             </Route>
//                             {/* added a layer for @theduefactory.com end */}

//                             <Route path="/home/teleperformance" element={<TelePerformanceNavigationScreen />}>
//                                 <Route index path="/home/teleperformance/attempted" element={<TeleAttempedScreen />} />
//                                 <Route path="/home/teleperformance/connected" element={<TeleConnectedScreen />} />
//                             </Route>

//                         </Route>
//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"]} />}>
//                             <Route path="/home/campaign-Dashboard-stats" element={< ClientAdminCampaignDashboard />} />
//                         </Route>

//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]} />}>
//                             <Route path="/home/addUser" element={<Navigate to="/home/addUser/list" replace />} />
//                             <Route path="/home/addUser" element={<OrgAdminScreen />}  >
//                                 <Route index path="/home/addUser/list" element={<OrgAdminListScreen />} />
//                                 <Route path="/home/addUser/createUser" element={<OrgAdminAddUserScreen />} />
//                                 <Route path="/home/addUser/list/:id" element={<OrgUsersDetailScreen />} />
//                                 <Route path="/home/addUser/list/editUser/:id" element={<><OrgUsersEditScreen /></>} />
//                             </Route>
//                         </Route>
//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_ADMIN"]} />}>
//                             <Route path="/home/myOrganization" element={<MyOrganization />} />
//                             <Route path="/home/myProfile/Edituser" element={<CreateOrganization />} />
//                         </Route>

//                         {/* <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_TEAM_LEAD"]} />}>
//                             <Route path="/home/teamLead/" element={<Navigate to="/home/teamLead/teamLeadAllocToTele" replace />} />
//                             <Route path="/home/teamLead/" element={<TeamLeadPlatformMainScreen />}>
//                                 <Route index path="/home/teamLead/teamLeadAllocToTele" element={<TdfUserAllocationToTcScreen />} />
//                                 <Route path="/home/teamLead/teamLeadAllocToTele/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
//                                 <Route path="/home/teamLead/teamLeadAllocFileIdToTele" element={<TdfUserFileIdAllocationScreen />} />
//                                 <Route path="/home/teamLead/teamLeadAllocFileIdToTele/:id" element={<TdfUserAllocToTcDetailScreen />} />
//                                 <Route path="/home/teamLead/teamLeadAllocFileIdToTele/detail/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
//                             </Route> */}
//                         {/* <Route path="/home/teamLeads" element={<TeamLeadsToTeleAllocationScreen />} />
//                             <Route path="/home/teamLeads/:id" element={<TeleCallerCustomerView />} /> */}
//                         {/* these two are the CRM starting phase routes so after discussion with gaurav, i commented these */}
//                         {/* <Route path="/home/teamLeadDashboard" element={<TeamLeadDashboardScreen />} />

//                         </Route> */}

//                         {/* createing new routes for new navigations button start */}
//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_TEAM_LEAD"]} />}>
//                             <Route path="/home/teamLead/" element={<Navigate to="/home/teamLead/teamLeadAllocToTele" replace />} />
//                             <Route path="/home/teamLead/" element={<TeamLeadPlatformMainNew />}>
//                                 <Route index path="/home/teamLead/teamLeadAllocToTele" element={<TdfProcessAdminPlatformAllocationNew />} />
//                                 <Route path="/home/teamLead/teamLeadAllocToTele/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />
//                                 {/* metadata routes start */}
//                                 <Route path="/home/teamLead/teamLeadAllocFileIdToTele" element={<ProcessAdminTdfAllocFileIdToTlScreenNew />} />
//                                 <Route path="/home/teamLead/teamLeadAllocFileIdToTele/:id" element={<ProcessAdminPlatformAllocToTlDetailNew />} />
//                                 <Route path="/home/teamLead/teamLeadAllocFileIdToTele/detail/:id" element={<ProcessAdminPlatformUserDetailScreenNew />} />

//                                 {/* metadata routes end */}
//                             </Route>

//                             <Route path="/home/teamLeadDashboard" element={<TeamLeadDashboardMain />}>
//                                 <Route path="/home/teamLeadDashboard/platform" element={<TeamLeadDashboardNew />} />
//                                 <Route path="/home/teamLeadDashboard/Client" element={<TeamLeadDashboardClient />} />
//                             </Route>


//                             {/* <Route path="/home/teamLeadDashboards" element={<TeamLeadDashboardScreen />} /> */}

//                         </Route>
//                         {/* createing new routes for new navigations button end */}



//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_TEAM_LEAD"]} />}>
//                             <Route path="/home/client/teamLead/" element={<Navigate to="/home/client/teamLead/teamLeadAllocToTele" replace />} />

//                             <Route path="/home/client/teamLead/" element={<TeamLeadClientMainScreen />}>
//                                 {/* <Route index path="/home/client/teamLead/teamLeadAllocToTele" element={<TeamLeadsToTeleAllocationScreen />} /> */}
//                                 <Route index path="/home/client/teamLead/teamLeadAllocToTele" element={<TeamLeadAllRecordViewScreen />} />
//                                 <Route index path="/home/client/teamLead/teamLeadAllocToTele/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
//                                 <Route index path="/home/client/teamLead/metaDataList" element={<TeamLeadClientMetaList />} />
//                                 <Route index path="/home/client/teamLead/metaDataList/:id" element={<TeamLeadClientAllocationToTc />} />
//                                 <Route index path="/home/client/teamLead/metaDataList/detail/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
//                             </Route>

//                         </Route>

//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD", "ROLE_TELE_CALLER"]} />}>
//                             <Route path="*" element={<NotFound />} />
//                         </Route>

//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_TELE_CALLER"]} />}>
//                             {/* <Route path="/home/teleCallers" element={<TeleCallerScreen />} /> */}
//                             <Route path="/home/teleCallers" element={<TeleCallerScreenAllocation />} />


//                             <Route path='/home/teleCallers/customerView/:id' element={<div style={{ marginTop: "10px", marginRight: "10px" }}><ProcessAdminClientCustomerViewScreenNew /> </div>} />
//                             {/* <Route path='/home/teleDashboard' element={<TeleCallersDashboard />} /> */}

//                             {/* Hot Leads routes - accessible to all telecallers */}
//                             <Route path="/home/hotLeads" element={<TeleCallerHotLeads/>} />
//                             <Route path="/home/hotLeads/:id" element={<TeleCallerHotLeadsDetailScreen />} />
//                         </Route>

//                         {/* creating routes layer for @theduefactory.com users so i can validate before outlet*/}
//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_TELE_CALLER"]} />}>
//                             <Route path="/home/" element={<TeleCallerPlatfomMain />}>
//                                 {/* <Route path="/home/teleTdfUsers" element={<TeleCallerTdfUsersScreen />} /> */}
//                                 <Route path="/home/teleTdfUsers" element={<TeleCallerTdfUsersNew />} />

//                                 {/* commeting the <TdfUserDetailScreen/> component and replacing with <ProcessAdminPlatformUserDetailScreenNew /> after discussion */}
//                                 {/* <Route path="/home/teleTdfUsers/:id" element={<TdfUserDetailScreen />} /> */}
//                                 <Route path="/home/teleTdfUsers/:id" element={<div style={{ marginTop: "10px", marginRight: "10px" }}><ProcessAdminPlatformUserDetailScreenNew /></div>} />
//                                 {/* <Route path="/home/userActions" element={<UserActionScreen />} /> */}
//                                 <Route path="/home/userActions" element={<UserActionScreenNew />} />


//                                 {/* <Route path="/home/userActions/:id" element={<TdfUserActionDetailScreen />} /> */}
//                                 <Route path="/home/userActions/:id" element={<div style={{ marginTop: "10px", marginRight: "10px" }}><ProcessAdminPlatformUserDetailScreenNew /></div>} />
//                             </Route>
//                         </Route>


//                         {/* These routes are no longer needed — they’re already covered in WordPress. start */}
//                         {/* <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_DM"]} />}>
//                             <Route path="/home/createBlog" element={<CreateBlogScreen />} />
//                             <Route path="/home/blogList" element={<BlogListingScreen />} />
//                             <Route path="/home/blogList/:id" element={<BlogDetailPage />} />
//                             <Route path="/home/blogList/:id/edit" element={<EditBlogScreen />} />
//                         </Route> */}
//                         {/* These routes are no longer needed — they’re already covered in WordPress. end */}


//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_DS"]} />}>
//                             <Route path="/home/utm/" element={<Navigate to="/home/utm/records" replace />} />
//                             <Route path='/home/utm/' element={<UtmMainScreen />}>
//                                 <Route index path="/home/utm/records" element={<UtmScreen />} />
//                                 <Route path="/home/utm/createCampaign/" element={<CreateUtmScreen />} />
//                             </Route>
//                             <Route path="/home/campaigns" element={<Navigate to="/home/campaigns/createCampaign/" replace />} />
//                             <Route path="/home/campaigns" element={<ProcessAdminCampaignMainScreen />}>
//                                 <Route path="/home/campaigns/createCampaign/" element={<CreateCampaignScreen />} />
//                             </Route>

//                         </Route>

//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD", "ROLE_TELE_CALLER", "ROLE_DS"]} />}>
//                             <Route path="/home/myProfile" element={<MyProfile />} />
//                         </Route>

//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD", "ROLE_DS"]} />}>
//                             <Route path="/home/campaigns" element={<Navigate to="/home/campaigns/records" replace />} />
//                             <Route path="/home/campaigns" element={<ProcessAdminCampaignMainScreen />}>
//                                 <Route index path="/home/campaigns/records" element={<ProcessAdminCampaignApproval />} />
//                                 <Route path="/home/campaigns/records/:id" element={<CampaignDetailsScreen />} />
//                             </Route>
//                         </Route>



//                         {/* new routes where i am working for reallocation & upload data and more, in progress  */}
//                         <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_MANAGER"]} />}>
//                             <Route path="processRecordAllocation/:type/:id" element={<ProcessManagerReallocation />} />
//                             <Route path="/home/processRecordAllocation" element={<ProccessAdminClientMainScreen />}>
//                                 <Route path="/home/processRecordAllocation/fileupload" element={<ExcelFileAllocationScreen />} />
//                             </Route>
//                         </Route>

//                         {/* tested routes end */}


//                         {/* created new routes only for the manager role */}
//                         {/* <Route path='/home' element={<RequireAuth allowedRoles={["ROLE_MANAGER"]} />}>                         
//                              <Route path="processRecordAllocation/:type/:id" element={<ProcessManagerReallocation />} />
//                         </Route> */}
//                         {/* catch All */}
//                         <Route path="/home" element={<RequireAuth allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"]} />}>
//                             <Route path="allocation" element={<ClientAllocationMainScreen />}>
//                                 {/* ✅ This will match /home/allocation */}
//                                 <Route index element={<Navigate to="metadata" replace />} />
//                                 <Route path="metadata" element={<MetaRecordScreen />} />
//                                 <Route path="metadata/:id" element={<MetaRecordDetailListScreen />} />
//                                 {/* added new routes only for the UI design start remove it after UI complete */}
//                                 <Route path="metadata/ClientListDetailsScreen" element={<ClientCampaignDetailsScreen />} />
//                                 <Route path="metadata/ClientListDetailsScreen/details/:id" element={<ClientCampaignDetailsScreenDetails />} />

//                                 {/* added new routes only for the UI design end */}
//                                 {/* "ProcessAdminClientCustomerViewScreen" this component need to be updated with the new component with the same routes start */}
//                                 {/* <Route path="metadata/details/:id" element={<ProcessAdminClientCustomerViewScreen />} /> */}
//                                 {/* "ProcessAdminClientCustomerViewScreen" this component need to be updated with the new component with the same routes end */}

//                                 {/* Now creating the New UI routes  for upper route path need to change this dummy routes and all places where using this routes start */}
//                                 <Route path="metadata/details/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />
//                                 {/* <Route path="metadata/details/:id" element={<ProcessAdminClientCustomerViewScreen />} /> */}




//                                 {/* Now creating the New UI routes  for upper route path need to change this dummy routes and all places where using this routes end */}
//                                 <Route path="all-records" element={<AllRecordListScreen />} />
//                                 {/* <Route path="all-records/:id" element={<ProcessAdminClientCustomerViewScreen />} /> */}
//                                 <Route path="all-records/:id" element={<ProcessAdminClientCustomerViewScreenNew />} />

//                                 <Route path="file-process" element={<FileUploadScreen />} />
//                                 {/* adding new routes for new screen, also delete old routes after testing completed */}
//                                 <Route path="metadata/:type/:id" element={<ProcessManagerReallocationNewScreen />} />
//                             </Route>
//                         </Route>
//                         <Route path="/home" element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD", "ROLE_DS"]} />}>
//                             <Route path="campaign" element={<ClientCampaignMainScreen />}>
//                                 {/* ✅ This will match /home/allocation */}
//                                 <Route index element={<Navigate to="list" replace />} />
//                                 <Route path="list" element={<ClientCampaignListScreen />} />
//                                 <Route path="list/:id" element={<ClientCampaignDetailScreen />} />
//                             </Route>
//                         </Route>
//                         <Route path="/home" element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD", "ROLE_DS"]} />}>
//                             <Route path="campaign" element={<ClientCampaignMainScreen />}>
//                                 <Route path="templates" element={<TemplateMainScreen />} />
//                                 <Route path="templates/:id" element={<StitchedTemplateDetailScreen />} />
//                                 <Route path="templates/details/:id" element={<IVRTemplateDetailScreen />} />

//                                 {/* <Route path="allLeads" element={<AllLeadsScreen />} />
//                                 <Route path="allLeads/:id" element={<AllLeadsDetailScreen />} />                                 */}
//                             </Route>
//                         </Route>
//                           <Route path="/home" element={<RequireAuth allowedRoles={["ROLE_MANAGER", "ROLE_TEAM_LEAD",]} />}>
//                             <Route path="campaign" element={<ClientCampaignMainScreen />}>                               
//                                 <Route path="allLeads" element={<AllLeadsScreen />} />
//                                 <Route path="allLeads/:id" element={<AllLeadsDetailScreen />} />                                
//                             </Route>
//                         </Route>

//                         <Route path="/home" element={<RequireAuth allowedRoles={["ROLE_CRM_ADMIN", "ROLE_MANAGER", "ROLE_ADMIN"]} />}>
//                             <Route path="analytic-dashbaord" element={<ClientDashboardScreen />} />
//                             <Route path="details/:id" element={<MetaRecordDetailListScreen />} />
//                         </Route>

//                     </Route>
//                 </Routes>
//             </Suspense>
//         </>
//     )
// }

export default App;